import BlockScope from "./../components/block-scope";
import CodeBlock from "./../code-block";
import ERRORS from "./../errors";
import _ from "underscore";
import { unpack } from "../../phaser-middleware/types/variable";

/**
 * IF block
 */
export default CodeBlock.extend({
  relations: CodeBlock.prototype.relations.concat([
    CodeBlock.prototype.createRelation("arguments", "args"),
    CodeBlock.prototype.createRelation("scope", "then"),
  ]),

  blueprint: require("./blueprints/if.json"),

  defaults: _.extend({}, CodeBlock.prototype.defaults, {
    args: {},
    then: {},
    "control-block": true,
  }),

  async execute(scope) {
    // compute arguments
    const args = await this.get("args").compute(scope);

    if (unpack(args)) {
      return this.get("then").run(scope);
    }
  },

  getPseudoCode(indent = "") {
    const args = this.get("args").getPseudoCode();
    const then = this.get("then").getPseudoCode(indent);

    return `${indent}IF${args} ${then}`;
  },

  getChildBlocks(list = []) {
    CodeBlock.prototype.getChildBlocks.call(this, list);
    this.get("args").getChildBlocks(list);
    this.get("then").getChildBlocks(list);
    return list;
  },

  getGlossaryTaxonomy() {
    return [
      "glossary-type.code-block.control.if",
      "glossary-type.code-block.control",
      "glossary-type.code-block",
    ];
  },

  _placementMessage: ERRORS.PLACEMENT_CONTROL,
  _validatePlacement(parent) {
    return parent instanceof BlockScope && !parent.get("free-form");
  },
});
